import { removeGuestToken } from 'lib/services/api/getAccessToken'
import { useAuth0 } from 'app/Auth'

export const useGuestAccess = () => {
  const { logout } = useAuth0()

  const logoutGuest = (): void => {
    removeGuestToken()
    logout({ returnTo: `${window.location.origin}/?status=loggedout` })
  }

  return {
    logoutGuest,
  }
}

export default useGuestAccess
